import { Quill } from 'react-quill';

const ListItem = Quill.import('formats/list/item');

export class CustomListItem extends ListItem {
	static tagName = 'LI';

	static create() {
		const node = super.create();

		node.setAttribute(
			'style',
			'font-style: normal; margin: unset; padding: unset; white-space: normal; overflow-wrap: break-word;'
		);

		return node;
	}

	static formats(domNode: HTMLElement) {
		return domNode.getAttribute('style');
	}

	format(name: string, value: any) {
		if (name === 'align') {
			this.domNode.style.textAlign = value || 'left';
		} else {
			super.format(name, value);
		}
	}
}
